// @flow

import React from 'react';

import {
  StyledPageCover,
  StyledCoverMaxWidthNoBottomMargin
} from '@components/Wrappers/styles/index';
import theme from '@lib/theme';
import { Link, useTranslation } from '@i18n';
import { DETAILS_DOCTOR } from '@routes';
import {
  LocationIcon,
  StyledBioHeading,
  StyledBioText,
  StyledBioTextWrapper,
  StyledBookButton,
  StyledButtonsWrapper,
  StyledButtonsWrapperMobile,
  StyledDepartment,
  StyledDoctorImage,
  StyledDoctorName,
  StyledDoctorPersonalInfo,
  StyledDoctorVariantCard,
  StyledDoctorVariantListWrapper,
  StyledExperienceHighlight,
  StyledExperienceStatictext,
  StyledHospitalName,
  StyledImageCover,
  StyledKnowMore,
  StyledLocation,
  StyledSpeciality,
  StyledVariantInner,
  StyledVariantInnerLeft,
  StyledVariantInnerRight
} from '../styles';
import type { DoctorVariantListProps } from './types';

const DoctorVariantList = ({ Doctors }: DoctorVariantListProps) => {
  const { t } = useTranslation(['Variants']);

  return (
    <StyledDoctorVariantListWrapper>
      {Doctors.map((doctor, idx) => (
        <StyledPageCover
          bgcolor={idx % 2 === 0 ? 'white' : theme.colors.whitishBlue}
          key={doctor.id}
        >
          <StyledCoverMaxWidthNoBottomMargin key={doctor.id}>
            <StyledDoctorVariantCard>
              <StyledVariantInner>
                <StyledVariantInnerLeft size={{ mobile: 1 / 3 }}>
                  <StyledImageCover>
                    <StyledDoctorImage src={doctor.attributes.image_url} alt="Doctor-Cover-Image" />
                  </StyledImageCover>
                  <StyledDoctorPersonalInfo>
                    <StyledDoctorName>{doctor.attributes.name}</StyledDoctorName>
                    <StyledDepartment>{doctor.attributes.job_role}</StyledDepartment>
                    <StyledLocation>
                      <LocationIcon src="/svg/costPage/location-mark.svg" alt="Location-Icon" />
                      {doctor.attributes.address_city}
                    </StyledLocation>
                  </StyledDoctorPersonalInfo>
                </StyledVariantInnerLeft>
                <StyledVariantInnerRight doctorCard size={{ mobile: 2 / 3 }}>
                  <StyledHospitalName>
                    <LocationIcon src="/svg/costPage/hospital-icon.svg" alt="Hospital-Icon" />
                    {doctor.relationships?.facility?.data?.attributes?.name || '-'}
                  </StyledHospitalName>
                  <StyledExperienceHighlight>
                    <LocationIcon src="/svg/costPage/doctor-icon.svg" alt="Doctor-Icon" />
                    {new Date().getFullYear()
                      - new Date(doctor.attributes.practicing_from).getFullYear()}
                    {' '}
                    +
                    <StyledExperienceStatictext>{t('Experience')}</StyledExperienceStatictext>
                    <StyledSpeciality>{doctor.attributes.speciality}</StyledSpeciality>
                  </StyledExperienceHighlight>
                  <StyledBioHeading>{t('Bio')}</StyledBioHeading>
                  <StyledBioTextWrapper>
                    <StyledBioText>
                      {doctor.attributes.highlights}
                    </StyledBioText>
                    <Link href={DETAILS_DOCTOR} params={{ slug: doctor.attributes.slug }} passHref>
                      <StyledKnowMore>{t('KnowMore')}</StyledKnowMore>
                    </Link>
                  </StyledBioTextWrapper>

                  <StyledButtonsWrapper>
                    <Link href={DETAILS_DOCTOR} params={{ slug: doctor.attributes.slug }} passHref>
                      <StyledBookButton>{t('BookButton')}</StyledBookButton>
                    </Link>

                  </StyledButtonsWrapper>
                </StyledVariantInnerRight>
                <StyledButtonsWrapperMobile>
                  <Link href={DETAILS_DOCTOR} params={{ slug: doctor.attributes.slug }} passHref>
                    <StyledBookButton>{t('BookButton')}</StyledBookButton>
                  </Link>
                </StyledButtonsWrapperMobile>
              </StyledVariantInner>
            </StyledDoctorVariantCard>
          </StyledCoverMaxWidthNoBottomMargin>
        </StyledPageCover>
      ))}
    </StyledDoctorVariantListWrapper>
  );
};

export default DoctorVariantList;
